import * as angular from 'angular';
import {RzSlider} from 'angular';
import {CustomerFilter} from 'modules/customers/model/CustomerFilter';
import '../modal.scss';

interface Scope extends ng.IScope {
    filter: CustomerFilter;
    sliderOptions: RzSlider.RzOptions;

    clear(): void;

    cancel(): void;

    apply(): void;

    ready: boolean;
}

export class EquityModal {

    static instance = (
        ev: MouseEvent,
        filter: CustomerFilter,
        opts: RangeOptionsDto,
        parent: Element | string = document.body
    ): angular.material.IDialogOptions => ({

        template: require('./equity-modal.html'),
        parent: angular.element(parent),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: false,

        controller: [
            '$scope', '$mdDialog', '$filter', 'opts',
            function (
                $scope: Scope,
                $mdDialog: angular.material.IDialogService,
                $filter: angular.IFilterService,
                opts: RangeOptionsDto
            ) {

                $scope.filter = angular.copy(filter);
                $scope.ready = false;

                if ($scope.filter.minEquity == null) $scope.filter.minEquity = opts.minEquityAmount;
                if ($scope.filter.maxEquity == null) $scope.filter.maxEquity = opts.maxEquityAmount;

                $scope.sliderOptions = <RzSlider.RzOptions>{
                    floor: opts.minEquityAmount,
                    ceil: opts.maxEquityAmount,
                    step: 1_000,
                    enforceRange: true,
                    translate: (v: number) => $filter('currency')(v, '$', 0)
                };

                $scope.clear = () => {
                    const cleared = angular.copy($scope.filter);
                    cleared.minEquity = null;
                    cleared.maxEquity = null;
                    $mdDialog.hide(cleared);
                };
                $scope.cancel = () => $mdDialog.cancel();
                $scope.apply = () => $mdDialog.hide(angular.copy($scope.filter));
            }
        ],
        onComplete: (scope: Scope) => {
            scope.$evalAsync(() => {
                scope.ready = true;
                scope.$broadcast('rzSliderForceRender');
            });
        },
        locals: {filter, opts}
    });
}

(EquityModal as any).$inject = ['$scope', '$mdDialog', '$filter', 'opts'];
